export default __webpack_public_path__ + "static/media/1472.91e84df0.png";